import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/invest_b1.png';
import _imports_1 from '@/assets/invest_b2.png';
import _imports_2 from '@/assets/invest_block3.png';
import _imports_3 from '@/assets/invest_block4.png';
import _imports_4 from '@/assets/invest_block2.png';
const _withScopeId = n => (_pushScopeId("data-v-348f3576"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "fs-s"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"block block1\" data-v-348f3576><div class=\"main-width d-flex jc-between ai-center content_box\" data-v-348f3576><div class=\"text-white text-left\" data-v-348f3576><div class=\"fs-xl fw-b light_blue title\" data-v-348f3576>WELL碳手印</div><div class=\"pt-20 fs-xl fw-b text_data\" data-v-348f3576>三维一体的投资理念</div><img class=\"invest_b1\" src=\"" + _imports_0 + "\" data-v-348f3576></div></div><img src=\"" + _imports_1 + "\" class=\"invest_b2\" data-v-348f3576></div><div class=\"block block2\" data-v-348f3576><div class=\"main-width d-flex ai-center jc-between content_box\" data-v-348f3576><div data-v-348f3576><div class=\"fs-xl fw-b pb-20 text-blue title\" data-v-348f3576>知止为魂、利他为身</div><div class=\"fs-xl fw-b pb-20 text_data\" data-v-348f3576>思想价值与文化投资</div></div><img src=\"" + _imports_2 + "\" width=\"500px\" data-v-348f3576></div></div><div class=\"block block3\" data-v-348f3576><div class=\"main-width d-flex ai-center jc-between content_box\" data-v-348f3576><div data-v-348f3576><div class=\"fs-xl fw-b pb-20 my_title\" data-v-348f3576>提速为能、增效为本</div><div class=\"fs-xl fw-b pb-20 text-white text_data\" data-v-348f3576>经营价值与战略投资</div></div><img src=\"" + _imports_3 + "\" width=\"500px\" data-v-348f3576></div></div><div class=\"block block5 bg-bggray\" data-v-348f3576><div class=\"main-width d-flex ai-center jc-between content_box\" data-v-348f3576><div data-v-348f3576><div class=\"fs-xl fw-b pb-20 text-blue my_title\" data-v-348f3576>减碳为体、降耗为用</div><div class=\"fs-xl fw-b pb-20 text_data\" data-v-348f3576>资产价值与责任投资</div></div><img src=\"" + _imports_4 + "\" data-v-348f3576></div></div>", 4);
const _hoisted_6 = {
  class: "block block_anli bg-lightgray"
};
const _hoisted_7 = {
  class: "main-width m_box"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title fs-xl fw-b text-white pb-40"
}, "投资案例", -1));
const _hoisted_9 = {
  class: "d-flex pl-10 pr-10",
  style: {
    "width": "100%"
  }
};
const _hoisted_10 = {
  class: "card_item d-flex"
};
const _hoisted_11 = {
  class: "item_right pl-20"
};
const _hoisted_12 = {
  class: "title pb-5 fw-b"
};
const _hoisted_13 = {
  class: "position text-blue fs-xs pb-20"
};
const _hoisted_14 = {
  class: "content fs-xs text-gray"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "min-width": "400px",
    "height": "100px"
  }
}, null, -1));
import { Select } from '@element-plus/icons-vue';
export default {
  __name: 'Invest',
  setup(__props) {
    const textData = {
      block1: '知止为魂，利他为身！(文化投资)<br>励节为责，奉俭为任！(责任投资)<br>提速为能，增效为本！(战略投资)<br>减碳为体，降耗为用！(资产投资)',
      block2: '计生存权益，量发展动能，<br>弘天人合一之道，扬格物致知之德！',
      block3: '在全球范围内，<br>我们的教育工作者正在引领运动，<br>推动健康低碳的场所。'
    };
    const loopList = [{
      content: '责任投资',
      color: '#9cbc11',
      des: '投资过程充分考虑环境、社会和公司因素'
    }, {
      content: '文化投资',
      color: '#0d6269',
      des: '促进碳手印文化市场交流，转播碳手印文化理念'
    }, {
      content: '价值投资',
      color: '#0896d4',
      des: '关注碳手印市场的真正内在价值'
    }];
    const acList = [{
      title: '浙江省行政中心',
      position: '见证不搬迁即完成智能改造的奇迹',
      content: '用户无需执行原定的搬迁和租赁计划，节省大量精力和财力。',
      src: require('@/assets/project_e1.jpg')
    }, {
      title: '小米移动互联网产业园',
      position: '精细化管理从智能物联网开始',
      content: '全球首例大规模物联网应用，全球首个大规模无源无线控制体系。',
      src: require('@/assets/project_e7.jpg')
    }, {
      title: '北大附中未来学校',
      position: '激发每一个孩子的创造力',
      content: '超过20个品类的小米生态链产品全面服务，呵护每一个孩子的日常生活，高频应用的智能产品激发孩子的创造力和参与感。',
      src: require('@/assets/project_e4.jpg')
    }, {
      title: '国网浙江综合能源服务公司',
      position: '电力服务新篇章、智能用电新模式',
      content: '为用户实现照明、空调、工位电源等全面的精细化计量，为用户实现全局智能化应用，实现可视化管理和数字化运营。',
      src: require('@/assets/project_e2.jpg')
    }];
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_el_scrollbar, {
        class: "el_scrollbar"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(acList, (item, idx) => {
          return _createElementVNode("div", {
            class: "news_card",
            key: idx
          }, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_image, {
            class: "img",
            fit: "cover",
            src: item.src
          }, null, 8, ["src"]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(item.position), 1), _createElementVNode("div", _hoisted_14, _toDisplayString(item.content), 1)])])]);
        }), 64)), _hoisted_15])]),
        _: 1
      })])])]);
    };
  }
};